import { AlimTalkAccountMode } from "../../../api/services/notification-center.service";
import { CapabilityUser, hasCapability } from "../../../common/permissions";

export type NotificationCenterPageId = "send" | "history" | "system" | "templates" | "channels" | "hq";

export const notificationCenterPages: Array<{
  id: NotificationCenterPageId;
  label: string;
  path: string;
}> = [
  { id: "send", label: "통합 발송", path: "/notification-center/send" },
  { id: "history", label: "통합 내역", path: "/notification-center/history" },
  { id: "system", label: "시스템 메시지 설정", path: "/notification-center/system" },
  { id: "templates", label: "알림톡 템플릿", path: "/notification-center/templates" },
  { id: "channels", label: "채널 설정", path: "/notification-center/channels" },
  { id: "hq", label: "HQ 관리", path: "/notification-center/hq" },
];

export const getAllowedNotificationCenterPages = (
  user: CapabilityUser,
  accountMode: AlimTalkAccountMode | null,
): NotificationCenterPageId[] => {
  const withHqPage = (pages: NotificationCenterPageId[]) => (
    user?.is_hq_admin === true ? [...pages, "hq" as const] : pages
  );
  if (user?.is_global_admin) {
    return notificationCenterPages
      .map((item) => item.id)
      .filter((page) => page !== "hq" || user.is_hq_admin === true);
  }
  if (hasCapability(user, "site_owner")) {
    return withHqPage(notificationCenterPages
      .map((item) => item.id)
      .filter((page) => page !== "hq" && (page !== "system" || accountMode === "DIRECT")));
  }
  if (hasCapability(user, "site_manager")) return withHqPage(["send", "history", "templates", "channels"]);
  if (hasCapability(user, "site_staff")) return withHqPage(["history"]);
  return withHqPage([]);
};

export const getNotificationCenterFallbackPage = (
  allowedPages: NotificationCenterPageId[],
): NotificationCenterPageId | null => (
  allowedPages.includes("send") ? "send" : allowedPages[0] || null
);

export const getNotificationCenterPage = (pageId: NotificationCenterPageId) => (
  notificationCenterPages.find((page) => page.id === pageId)
);

export const getNotificationCenterPageIdFromPath = (pathname: string): NotificationCenterPageId | null => (
  notificationCenterPages.find((page) => page.path === pathname)?.id || null
);

export const isNotificationCenterPageId = (value: string | null): value is NotificationCenterPageId => (
  notificationCenterPages.some((page) => page.id === value)
);
